/**
 * Keeps the softphone's own view of the account's call-buying limits in step with the billing
 * module's.
 *
 * A WATCHER rather than a dispatch tacked onto the end of `getBuyerAccountBalance`, for two
 * reasons. The balance is refreshed from five places - the dashboard route guard, the header's 45
 * second poll, the re-check before going live, Add Funds, the billing pages - and every one of them
 * has to reach the widget, or the agent is back to a Ready badge that is only true until someone
 * spends the account down. And the dependency belongs this way round: the softphone cares what the
 * limits are, while the billing module has no business knowing there is a softphone at all.
 *
 * Only the FLAGS are watched, never the figures. Whether the account may buy calls is the server's
 * answer - it knows the account's minimum balance, its pre-pay/post-pay terms, its credit and what
 * it has spent today - and amounts compared against limits here would be a second, worse copy of
 * those rules.
 *
 * The two are watched as ONE object so the precedence between them is applied to a consistent pair.
 * Watched separately, a refresh that cleared the balance and set the budget in the same commit
 * would fire twice and flash the wrong badge in between.
 *
 * That object is rebuilt on every evaluation, which Vue cannot compare by value - so this fires on
 * every balance refresh, unchanged flags included. Deliberately left that way rather than
 * hand-rolling a comparison here: `setAccountCallBuyingLimits` already returns without touching
 * anything when the answer has not moved, and that is the guard that matters - it is the one
 * standing in front of the status mutation and the broadcast to every other tab.
 */
export default function softphoneBalancePlugin(store) {
  store.watch(
    state => ({
      isBalanceLow: state.billing.accountBalance?.isBalanceLow === true,
      isDailyBudgetReached: state.billing.accountBalance?.isDailyBudgetReached === true
    }),
    limits => store.dispatch('softphone/setAccountCallBuyingLimits', limits)
  )
}
